import React from 'react';
import { features, casalePhotos } from '../mock';
import { Leaf, Droplets, Bed, UtensilsCrossed } from 'lucide-react';

const icons = [Droplets, Leaf, Bed, UtensilsCrossed];

const About = () => {
  return (
    <section id="about" className="relative bg-[#faf7f2] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-14 lg:gap-24 items-center">
        <div className="relative">
          <div className="relative overflow-hidden h-[520px] bg-[#f3ede0] flex items-center justify-center">
            <img
              src={casalePhotos.pietraGeniusLoci}
              alt="La lastra in pietra Genius Loci scolpita a mano"
              className="max-h-full max-w-full object-contain rotate-90 grayscale-[10%] hover:grayscale-0 hover:scale-105 transition-all duration-[1200ms]"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 md:-right-10 w-40 h-40 md:w-52 md:h-52 border border-[#3A4A2C]/30 hidden md:block"></div>
          <div className="absolute -top-6 -left-6 hidden md:flex flex-col items-center gap-2">
            <div className="w-px h-16 bg-[#3A4A2C]/40"></div>
            <span className="font-serif italic text-[#3A4A2C] text-sm">est. 2013</span>
          </div>
        </div>

        <div>
          <p className="text-[#C87355] text-xs tracking-[0.4em] uppercase mb-5">Il Casale</p>
          <h2 className="font-serif text-[#1f1f1f] text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-8">
            Lo spirito<br />
            <span className="italic text-[#3A4A2C]">augurale</span> del luogo.
          </h2>
          <p className="text-[#4a4a4a] leading-relaxed text-base md:text-lg mb-5">
            <span className="font-serif italic text-[#3A4A2C]">Genius Loci</span> è situata nel cuore della verde Umbria, terra d’Arte millenaria, di operose maestrie dell’artigianato e di storica gastronomia che affonda le proprie radici nella civiltà etrusca e romana.
          </p>
          <p className="text-[#4a4a4a] leading-relaxed text-base md:text-lg mb-10">
            Una lastra in pietra scolpita a mano accoglie gli ospiti all’ingresso: un simbolo di buon auspicio che raffigura il Genius Loci, la divinità che secondo gli antichi Romani era legata a un luogo fino ad esserne l’anima.
          </p>

          <a
            href="#gallery"
            className="inline-flex items-center gap-3 text-sm tracking-[0.25em] uppercase text-[#3A4A2C] group"
          >
            <span className="w-10 h-px bg-[#3A4A2C] group-hover:w-16 transition-all duration-300"></span>
            Chi siamo
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-24 md:mt-32 grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-10">
        {features.map((f, i) => {
          const Icon = icons[i];
          return (
            <div key={f.title} className="group">
              <div className="w-14 h-14 rounded-full border border-[#3A4A2C]/25 flex items-center justify-center mb-6 group-hover:bg-[#3A4A2C] group-hover:border-[#3A4A2C] transition-all duration-500">
                <Icon className="text-[#3A4A2C] group-hover:text-[#faf7f2] transition-colors" size={22} />
              </div>
              <h4 className="font-serif text-[#1f1f1f] text-xl md:text-2xl mb-2">{f.title}</h4>
              <p className="text-[#666] text-sm leading-relaxed">{f.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default About;
